import { Component } from '@angular/core';
import { ListingSyncService } from '../listing-sync.service';
import { PopoverPositions } from '@vendasta/galaxy/popover';
import { Observable } from 'rxjs';
import { SyncingProgressSummaryData, SyncingProgressSyncLegendConfig } from '../../local-seo';

@Component({
  selector: 'local-seo-syncing-progress-summary-card',
  templateUrl: './syncing-progress-summary-card.component.html',
  styleUrls: ['./syncing-progress-summary-card.component.scss'],
  standalone: false,
})
export class SyncingProgressSummaryCardComponent {
  summaryData$: Observable<SyncingProgressSummaryData>;
  PopoverPositions = PopoverPositions;
  showPopover = false;

  syncingProgressLegendConfig = SyncingProgressSyncLegendConfig;

  constructor(private readonly listingSyncService: ListingSyncService) {
    this.summaryData$ = this.listingSyncService.syncingProgressSummaryData$;
  }

  showPopovers(): void {
    this.showPopover = true;
  }

  hidePopovers(): void {
    this.showPopover = false;
  }

  getSyncValueBgColor(data: SyncingProgressSummaryData): string {
    const ratio = data?.syncedSourcesCount / data?.totalSourcesCount;
    if (ratio >= 0.75) {
      return 'sync-green';
    }
    if (ratio >= 0.5) {
      return 'syncing-green';
    }
    return 'not-syncing-grey';
  }
}
